var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workOrder"},[_c('tab',{attrs:{"tab":_vm.tab}}),_c('div',{staticClass:"workOrder-container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }